import { render, staticRenderFns } from "./addMenuBtn.vue?vue&type=template&id=9cc85f1c"
import script from "./addMenuBtn.vue?vue&type=script&lang=js"
export * from "./addMenuBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports